
import { defineComponent, PropType, computed } from "vue";
import Datepicker from "vue3-date-time-picker";
export default defineComponent({
  name: "DateInput",
  components: { Datepicker },
  props: {
    input: { type: Object as PropType<any>, required: true },
    modelValue: { type: [String, Date], default: null },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });
    return { model };
  },
});
